// extracted by mini-css-extract-plugin
export default {"PropertyInventoryScreen":"PropertyInventoryScreen_PropertyInventoryScreen__gRiho","LoadingPlaceholder":"PropertyInventoryScreen_LoadingPlaceholder__J6Wuw"};